import { Container, Header, SpaceBetween, Tabs, Button } from "@cloudscape-design/components"
import Flashbar from "@cloudscape-design/components/flashbar";
import { faArrowUpFromBracket, faCheck, faTable } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import BrowseExtensionsTab from "components/clusterExtensions/BrowseExtensionsTab"
import CustomExtensionsTab from "components/clusterExtensions/CustomExtensionsTab"
import InstalledExtensionsTab from "components/clusterExtensions/InstalledExtensionsTab"
import { useCluster } from "contexts/ClusterContext"
import NEW_PLANS from "configs/newPlans.json";
import { useBreadcrumbs } from "contexts/BreadcrumbContext";
import { useEffect, useState } from "react";
import AppConfig from "configs/AppConfig";

function ExtensionsPage() {
     const { setBreadcrumbs } = useBreadcrumbs();
    const { selectedCluster, selectedClusterDetails } = useCluster();
    const [refreshKey, setRefreshKey] = useState(0);
    
useEffect(() => {
        if (selectedClusterDetails?.name) {
            setBreadcrumbs([
                { text: AppConfig.APP_NAME, href: "/" },
                { text: "Dedicated Clusters", href: "/dedicated-clusters" },
                { text: selectedClusterDetails.name, href: `/dedicated-clusters/${selectedClusterDetails?.id}` },
                { text: "Extensions", href: `/dedicated-clusters/${selectedClusterDetails?.id}/extensions` }
            ]);
        }

        // Cleanup when component unmounts
        return () => {
            setBreadcrumbs([]);
        };
    }, [selectedClusterDetails, setBreadcrumbs]);

    if(!selectedCluster){
        return (
            <Flashbar
                        items={[
                        {
                            type: "warning",
                            content:
                            "Please select a cluster first to access extensions.",
                        },
                        ]}
                    />
        );
    }


    const selectedPlan = NEW_PLANS.find((plan)=> plan.name.toLowerCase() === selectedClusterDetails?.payment_status?.plan);


    // Prevent access to extensions when they are not supported by the selected cluster's plan
    if(selectedPlan?.extensionAccess === "none"){
        return (
            <Container>
                Extensions are not available for this cluster's plan.
            </Container>
            
        );
    }


    const isCustomExtensionsSupported = selectedPlan?.extensionAccess === "all"

    
    return (
        <SpaceBetween size="xl">
            <div className="extension-header-container">
                <Header variant="h2" description="Enhance your Keycloak cluster with powerful extensions and integrations."
                info={
                    <Button
                        variant="icon"
                        iconName="refresh"
                        ariaLabel="Refresh extensions"
                        onClick={() => setRefreshKey((previous) => previous + 1)}
                    />
                    }
                >
                    Extensions
                </Header>
                {selectedClusterDetails?.status !== "active" && (
                    <Flashbar
                        items={[
                        {
                            type: "warning",
                            content:
                            "Cluster is not active. You cannot install or uninstall extensions.",
                        },
                        ]}
                    />
                )}
            </div>

            <Tabs
                tabs={[
                    {
                        label: <div>
                                <FontAwesomeIcon
                                    icon={faTable}
                                    className="margin-right-10"
                                />
                                Browse Extensions
                            </div>,
                        id: "browse",
                        content: <BrowseExtensionsTab refreshKey={refreshKey}/>
                    },
                    {
                        label: <div>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    className="margin-right-10"
                                />
                                Installed Extensions
                            </div>,
                        id: "installed",
                        content: <InstalledExtensionsTab refreshKey={refreshKey} />
                    },
                    {
                        label: <div>
                                <FontAwesomeIcon
                                    icon={faArrowUpFromBracket}
                                    className="margin-right-10"
                                />
                                Custom Extensions
                            </div>,
                        id: "custom",
                        disabled: !isCustomExtensionsSupported,
                        content: <CustomExtensionsTab refreshKey={refreshKey}/>
                    }
                ]}
            />
        </SpaceBetween>
    )
}

export default ExtensionsPage
